export const subscription = decode('c3Vic2NyaXB0aW9u');
export const subscriptions = decode('c3Vic2NyaXB0aW9ucw==');
export const purchasable = decode('cHVyY2hhc2FibGU=');
export const purchasableSubscriptions = decode('cHVyY2hhc2FibGVTdWJzY3JpcHRpb25z');

export const USER_SUBSCRIPTIONS = decode('VVNFUl9TVUJTQ1JJUFRJT05T');
export const userSubscription = decode('dXNlclN1YnNjcmlwdGlvbg==');

export const customerSubscriptions = decode('Y3VzdG9tZXJTdWJzY3JpcHRpb25z');
export const isTrial = decode('aXNUcmlhbA==');
export const isActive = decode('aXNBY3RpdmU=');
export const premiumFeatures = decode('cHJlbWl1bUZlYXR1cmVz');
export const expirationDate = decode('ZXhwaXJhdGlvbkRhdGU=');
export const activationDate = decode('YWN0aXZhdGlvbkRhdGU=');
export const billingInterval = decode('YmlsbGluZ0ludGVydmFs');
export const contractTerm = decode('Y29udHJhY3RUZXJt');
export const billingIssue = decode('YmlsbGluZ0lzc3Vl');
export const autoRenew = decode('YXV0b1JlbmV3');
export const nextBillingDate = decode('bmV4dEJpbGxpbmdEYXRl');
export const promoEndDate = decode('cHJvbW9FbmREYXRl');

// Trails
export const trailsBaseUrl = decode('L2N1cmF0ZWQtY291cnNlL2NvdXJzZS9jdXJhdGVk'); // '/curated-course/course/curated'
export const tripReportsKey = decode('dHJpcFJlcG9ydHM='); // 'tripReports'
export const tripReportsBaseUrl = decode('L2N1cmF0ZWQtY291cnNlL3RyaXAvcmVwb3J0'); // '/curated-course/trip/report'
export const course = decode('Y291cnNl'); // 'course'
export const trailsHash = decode('dHJhaWxz');
export const hasTrailsSubscriptionHash = decode('aGFzVHJhaWxzU3Vic2NyaXB0aW9u');
export const trailsReviewSortHash = decode('dHJhaWxzUmV2aWV3U29ydA==');
export const garminTrailsRoleValueHash = decode('Z2FybWluVHJhaWxzUm9sZVZhbHVl');
export const isGarminTrailsPageHash = decode('aXNHYXJtaW5UcmFpbHNQYWdl');
export const GarminTrailsPageHash = decode('R2FybWluVHJhaWxzUGFnZQ==');
export const showGarminTrailsShareModalHash = decode('c2hvd0dhcm1pblRyYWlsc1NoYXJlTW9kYWw=');
export const GARMIN_TRAILS_TRAIL_LIST_Hash = decode('R0FSTUlOX1RSQUlMU19UUkFJTF9MSVNU');
export const GARMIN_TRAILS_TRAIL_DETAILS_Hash = decode('R0FSTUlOX1RSQUlMU19UUkFJTF9ERVRBSUxT');

// Active Intelligence
export const CONSENT_TYPE_AI = decode('RElfQ09OTkVDVF9BSQ=='); // 'DI_CONNECT_AI'
export const CONSENT_KEY_AI = decode('Q09OTkVDVF9BSQ=='); // 'CONNECT_AI
export const garminTrailsHash = decode('Z2FybWluX3RyYWlscw==');
export const shouldShowTrailsPromptHash = decode('c2hvdWxkU2hvd1RyYWlsc1Byb21wdA==');
export const isTrailDetailPageHash = decode('aXNUcmFpbERldGFpbFBhZ2U=');
export const isMyTrailReviewsPageHash = decode('aXNNeVRyYWlsUmV2aWV3c1BhZ2U=');
export const trailDamamageHash = decode('VFJBSUxfREFNQUdF');
export const conditionsTrailDamageHash = decode('Y29uZGl0aW9uc190cmFpbF9kYW1hZ2U=');
export const trailHash = decode('dHJhaWw=');
export const myTrailReviewsHash = decode('bXktdHJhaWwtcmV2aWV3cw==');
export const GarminTrailHash = decode('R2FybWluVHJhaWw=');
export const GarminTrailDetailsHash = decode('R2FybWluVHJhaWxEZXRhaWxz');
export const isGarminTrailHash = decode('aXNHYXJtaW5UcmFpbA==');
export const GARMIN_TRAIL_Hash = decode('R0FSTUlOX1RSQUlM');
export const isMyTrailsReviewPageHash = decode('aXNNeVRyYWlsc1Jldmlld1BhZ2U=');

// Codes
export const LiveSessionView = decode('TGl2ZVNlc3Npb25WaWV3');
export const Messaging = decode('TWVzc2FnaW5n');
export const LiveTrack = decode('TGl2ZVRyYWNr');
export const Trails = decode('VHJhaWxz');
export const ConnectPlus = decode('Q29ubmVjdFBsdXM=');
export const ProfileImageFrame = decode('UHJvZmlsZUltYWdlRnJhbWU=');
export const AnnualReport = decode('QW5udWFsUmVwb3J0');
export const SocialImprovements = decode('U29jaWFsSW1wcm92ZW1lbnRz');
export const AdvancedReporting = decode('QWR2YW5jZWRSZXBvcnRpbmc=');

function decode(str) {
    return atob(str);
}
